import _ from 'lodash';

import { EventEmitter } from '@angular/core';

import MainMarker from 'Images/generic_marker.png';
import template from './editEquipments.html';

/* @ngInject */
function EditEquipmentsController(
  $scope,
  $document,
  growl,
  EquipmentInfoService,
  GroupService,
  GroupsButtonService,
  MapService,
  appConfig
) {
  const vm = this;
  const { LatLng, Marker, Point, Size } = google.maps;
  const ICON_WIDTH = 25;
  const ANCHOR_LAT = ICON_WIDTH / 2;
  const ICON_HEIGHT = 33;
  const invalidFields = {
    equipmentType: 'Please select an equipment type',
    name: 'Please provide a name',
    group: 'Please select a group',
    json: 'Please provide valid json',
    org: 'Please select an organization'
  };

  let map;
  let image;
  let marker = null;

  vm.groupList = [];
  vm.submit = submit;
  vm.updateLatLong = updateLatLong;
  vm.updateSettings = updateSettings;
  vm.equipmentModalInfo = {
    disableSaveButton: false,
    isConfigValidJSON: true
  };
  vm.onFormFeedback = onFormFeedback;
  vm.notifyChange = new EventEmitter();
  vm.onFormReady = onFormReady;

  vm.$onInit = () => {
    const { newEquipment } = vm;
    vm.selectedGroups = newEquipment && _.size(newEquipment.groups) ? angular.copy(newEquipment.groups) : [];

    if (!newEquipment.settings) {
      vm.newEquipment.settings = getDefaultSettings(newEquipment.equipmentType);
    }

    vm.nvrEquipment = getNVREquipmentOnRCU();

    generateFormInfo();
  };

  vm.$postLink = () => {
    image = {
      url: MainMarker,
      size: new Size(ICON_WIDTH, ICON_HEIGHT),
      origin: new Point(0, 0),
      anchor: new Point(ANCHOR_LAT, ICON_HEIGHT)
    };
    const NEW_ZOOM = 3;
    const EDIT_ZOOM = NEW_ZOOM * 5;
    map = new MapService.Map($document[0].getElementById('equipment-location'), 'edit-equipments-modals', {
      zoom: vm.editing ? EDIT_ZOOM : NEW_ZOOM,
    });

    const { latitude: lat, longitude: lng } = _.get(vm.newEquipment, 'settings', {});
    if (lat && lng) {
      const position = new LatLng(lat, lng);
      marker = new Marker({
        map,
        position,
        icon: image
      });
    }

    const DEFAULT_LAT = 32;
    const DEFAULT_LNG = -97;
    map.setCenter(marker ? marker.getPosition() : new LatLng(DEFAULT_LAT, DEFAULT_LNG));

    // ////////////
    // Listeners //
    // ////////////
    google.maps.event.addListener(map, 'click', ({ latLng }) => {
      $scope.$apply(() => {
        _.assign(vm.newEquipment.settings, {
          latitude: latLng.lat(),
          longitude: latLng.lng(),
        });
        updateLatLong();
      });
    });

    if (!vm.editing) {
      // Can't change type when editing anyway
      $scope.$watch(() => vm.newEquipment.equipmentType, (type) => {
        vm.newEquipment.settings = getDefaultSettings(type);
        generateFormInfo();
      }, true);
    }

    $scope.$watch(() => vm.updatedOrg, () => {
      const id = vm.updatedOrg;
      if (id) {
        GroupService.getGroupByOrg(id).then(({ body }) => {
          vm.groupList = [body];
        }).catch((error) => {
          growl.error(error, { title: 'Could not get groups for selected organization' });
        });
      } else {
        GroupService.getGroupTree().then(({ data }) => {
          vm.groupList = data;
        });
      }
    });
  };

  function generateFormInfo() {
    vm.model = vm.newEquipment.settings;
    vm.formOptions = {
      formType: `equipment.${vm.newEquipment.equipmentType}`,
      title: 'Settings',
      buildFromSchema: false,
    };
    vm.formEvalContext = {
      nvrList: vm.nvrEquipment
    };
  }

  function updateSettings(update) {
    const { model } = update;
    $scope.$apply(() => {
      // keep original reference so we don't cause an infinite change loop
      model !== vm.model && angular.copy(model, vm.model);
    });
    updateMap();
  }

  vm.$onDestroy = () => {
    google.maps.event.clearListeners(map, 'click');
    if (marker) {
      marker.setMap(null);
    }
    MapService.destroyGoogleMaps('#equipment-location');
  };

  function submit() {
    const { newEquipment } = vm;
    vm.selectedGroups = GroupsButtonService.rebuildSelectedGroups();
    const reasons = formIsInvalid();
    if (reasons) {
      growl.error(reasons, {
        disableCloseButton: false
      });
    } else {
      let growlMessage = growl.info('Saving Changes..', {
        disableCloseButton: true
      });
      vm.equipmentModalInfo.disableSaveButton = true;


      const eqObject = angular.copy(newEquipment);
      eqObject.groups = _.map(vm.selectedGroups, 'id');
      eqObject.org = vm.updatedOrg;

      // Remove jobs.vehuv2 if it exists before saving
      if (eqObject?.settings?.jobs?.vehuv2) {
        delete eqObject.settings.jobs.vehuv2;
      }

      const addEdit = eqObject.id ?
        EquipmentInfoService.editEquipment({
          id: eqObject.id,
          name: eqObject.name,
          equipmentType: eqObject.equipmentType,
          settings: eqObject.settings,
          groups: eqObject.groups,
          org: eqObject.org
        }) :
        EquipmentInfoService.addEquipment(eqObject);
      addEdit
        .then((equipment) => {
          growlMessage.destroy();
          growlMessage = growl.success('Saved successfully...');
          vm.close(equipment);
        })
        .catch((res) => {
          growlMessage.destroy();
          growlMessage = growl.error(res.error, { title: 'Error while saving:' });
        })
        .finally(() => { vm.equipmentModalInfo.disableSaveButton = false });
    }
  }

  function formIsInvalid() {
    const { equipmentType, name, settings } = vm.newEquipment;
    const checks = {
      equipmentType: () => !equipmentType,
      name: () => !name,
      group: () => !_.size(vm.selectedGroups),
      json: () => typeof settings !== 'object',
      org: () => !vm.updatedOrg
    };

    return _.reduce(
      checks,
      (reasons, validate, field) => validate() ? `${reasons && `${reasons}\n`}- ${invalidFields[field]}` : reasons,
      ''
    );
  }

  function updateLatLong() {
    updateMap();
    triggerNotifyChange();
  }

  function updateMap() {
    const { latitude, longitude } = vm.newEquipment?.settings || {};
    if (_.some([latitude, longitude], _.isUndefined)) { return }

    const position = new LatLng(latitude, longitude);
    if (!marker || !marker.getPosition().equals(position)) {
      marker = marker || new Marker({ map, position, icon: image });
      marker.setPosition(position);
    }
    map.setCenter(position);
  }

  function getDefaultSettings(type = vm.newEquipment.equipmentType) {
    return _.cloneDeep(_.get(appConfig.equipmentTypes, [type, 'defaultSettings'], {}));
  }

  function triggerNotifyChange() {
    // Only emit the fields that were actually changed (lat/long from map click).
    // Emitting the entire model would overwrite form values that weren't propagated
    // to vm.model due to form being invalid (e.g., when required fields are empty).
    const { latitude, longitude } = vm.model;
    vm.notifyChange.emit({
      model: { latitude, longitude }
    });
  }

  function onFormFeedback(event) {
    if (event.type === 'isValid') {
      $scope.$apply(() => {
        vm.equipmentModalInfo.disableSaveButton = !event.data;
      });
    }
  }

  function onFormReady({ formio }) {
    vm.dynamicForm = formio;
  }

  function getNVREquipmentOnRCU() {
    const rcuId = _.get(vm.newEquipment, 'rcu.id', vm.newEquipment.rcu);
    if (!rcuId) {
      return;
    }
    const rcuEquipment = EquipmentInfoService.model.byRCU[rcuId];
    const nvrEquipment = _.map(
      _.filter(rcuEquipment, { equipmentType: 'axisNvr' }),
      ({ name: label, id }) => ({ label, value: id, id })
    );
    return nvrEquipment;
  }
}

export default {
  name: 'editEquipments',
  template,
  controller: EditEquipmentsController,
  bindings: {
    editing: '<',
    newEquipment: '<',
    close: '<',
    dismiss: '<'
  }
};
